import { GetAvailablePlansOptions } from '@dtx-company/inter-app/src/api/subscription-service/getAvailablePlans'
import { UseAPIOptions } from '@dtx-company/inter-app/src/hooks/useAPI'
import {
  UseAvailablePlansConfig,
  UseAvailablePlansResponse,
  useAvailablePlansSWR
} from './useAvailablePlansSWR'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { usePlanPricingGroup } from '@dtx-company/inter-app/src/hooks/usePlanPricingGroup/usePlanPricingGroup'

type UseCurrentAvailablePlansOptions = UseAPIOptions<
  Omit<GetAvailablePlansOptions, 'token' | 'filter'> & {
    filter?: Omit<GetAvailablePlansOptions['filter'], 'planPricingGroup'>
  }
>

/**
 * Wraps useAvailablePlansSWR setting the planPricingGroup.
 */
export function useCurrentAvailablePlansSWR(
  options: UseCurrentAvailablePlansOptions,
  config?: UseAvailablePlansConfig
): UseAvailablePlansResponse {
  const authState = useAuthState()
  const planPricingGroup = usePlanPricingGroup()

  return useAvailablePlansSWR(() => {
    const evaluatedOptions = typeof options === 'function' ? options() : options
    if (!evaluatedOptions) return
    if (!authState.token) return
    return {
      ...evaluatedOptions,
      filter: {
        ...evaluatedOptions.filter,
        planPricingGroup
      },
      token: authState.token
    }
  }, config)
}
